import React, { useEffect, useState } from 'react';
import { groupProductsByCategory } from '../../utils';
import styles from './dpsProductGroup.module.scss';
import DpsListItem from '../DpsListItem';
import DpsProductGroupHeader from '../DpsProductGroupHeader';

function DpsProductGroup(props) {
    const {
        filteredResults,
        keyName,
        isAllProductsActive,
        reportingDataOnClickEvent,
    } = props;
    const [groupedItems, setGroupedItems] = useState(
        groupProductsByCategory(filteredResults, isAllProductsActive),
    );

    useEffect(() => {
        const groupProducts = groupProductsByCategory(
            filteredResults,
            isAllProductsActive,
        );
        setGroupedItems(groupProducts);
    }, [filteredResults]);

    return (
        <div className={styles['dpsproduct-group-wrapper']}>
            {Object.entries(groupedItems).map(([key, val]) => (
                <>
                    <DpsProductGroupHeader category={key} />
                    {val.map((item, i) => (
                        <DpsListItem
                            key={`${item.name}_${keyName}`}
                            content={item}
                            index={i}
                            reportingDataOnClickEvent={
                                reportingDataOnClickEvent
                            }
                        />
                    ))}
                </>
            ))}
        </div>
    );
}

export default DpsProductGroup;
